import { Link } from "react-router-dom";
import { supabase } from "@/lib/supabaseClient";
import { useEffect, useState } from "react";

export default function HomePage() {
  const [status, setStatus] = useState<string>("Checking...");
  useEffect(() => {
    (async () => {
      try {
        const { error } = await supabase.from("cases").select("id").limit(1);
        if (error) throw error;
        setStatus("Connected to Supabase");
      } catch {
        setStatus("Supabase connection failed");
      }
    })();
  }, []);

  return (
    <div className="container py-8 space-y-6">
      <div className="p-4 border rounded-md">
        <div className="font-medium">Supabase status</div>
        <div className="text-sm text-muted-foreground">{status}</div>
      </div>
      <nav className="space-x-4">
        <Link className="underline" to="/cases">All Cases</Link>
        <Link className="underline" to="/cases?new=1">Create New Case</Link>
        <Link className="underline" to="/case/test">Test Thread View</Link>
      </nav>
    </div>
  );
}

